var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugHouseholdAMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33,14h-4c-1.1030273,0-2,0.8974609-2,2v16c0,1.1025391,0.8969727,2,2,2h4c1.1030273,0,2-0.8974609,2-2V16 C35,14.8974609,34.1030273,14,33,14z M29,32V16h4l0.0014648,16H29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,14h-4c-1.1030273,0-2,0.8974609-2,2v16c0,1.1025391,0.8969727,2,2,2h4c1.1030273,0,2-0.8974609,2-2V16 C21,14.8974609,20.1030273,14,19,14z M15,32V16h4l0.0014648,16H15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.40625,8.0810547C41.8393555,7.3945312,40.9985352,7,40.0996094,7H7.9003906 C7.0014648,7,6.1606445,7.3945312,5.59375,8.0810547C3.9121094,10.1162109,0,15.7431641,0,24 s3.9121094,13.8837891,5.59375,15.9189453C6.1606445,40.6054688,7.0014648,41,7.9003906,41h32.1992188 c0.8989258,0,1.7397461-0.3945312,2.3066406-1.0810547C44.0878906,37.8837891,48,32.2568359,48,24 S44.0878906,10.1162109,42.40625,8.0810547z M40.8642578,38.6455078C40.6782227,38.8710938,40.3994141,39,40.0996094,39H7.9003906 c-0.2998047,0-0.5786133-0.1289062-0.7646484-0.3544922C5.5913086,36.7763672,2,31.6074219,2,24 S5.5913086,11.2236328,7.1357422,9.3544922C7.3217773,9.1289062,7.6005859,9,7.9003906,9h32.1992188 c0.2998047,0,0.5786133,0.1289062,0.7646484,0.3544922C42.4086914,11.2236328,46,16.3925781,46,24 S42.4086914,36.7763672,40.8642578,38.6455078z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugHouseholdAMedium);
export default __webpack_public_path__ + "static/media/plug-household-a--medium.b6714d5702abdc9d310d1d90d819ad14.svg";
export { ForwardRef as ReactComponent };